
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Star, Heart } from 'lucide-react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      quote: "An absolutely delightful way to explore NYC history through the lens of our feline friends. Peggy's research is impeccable!",
      author: "Sarah M.",
      role: "Tour Guest",
      rating: 5
    },
    {
      quote: "I never knew cats played such an important role in Brooklyn's history. This tour was both educational and entertaining.",
      author: "Michael K.",
      role: "History Enthusiast", 
      rating: 5
    },
    {
      quote: "Perfect for cat lovers and history buffs alike. The stories are fascinating and the guides are knowledgeable.",
      author: "Jennifer L.",
      role: "Travel Blogger",
      rating: 5
    }
  ];

  return (
    <section className="space-y-12">
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-[#894D1D] to-[#698235] rounded-full mb-6">
          <Heart className="h-8 w-8 text-white" />
        </div>
        <h2 className="text-4xl font-montserrat font-bold text-[#894D1D] mb-4">
          What People Are Saying
        </h2>
        <p className="text-lg text-[#894D1D]/70 font-montserrat max-w-2xl mx-auto">
          Testimonials from tour guests and media professionals
        </p>
      </div>
      
      <div className="grid md:grid-cols-3 gap-8">
        {testimonials.map((testimonial, index) => (
          <Card key={index} className="bg-white border-[#894D1D]/10 shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
            <CardContent className="p-8">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, starIndex) => (
                  <Star key={starIndex} className="h-5 w-5 fill-[#698235] text-[#698235]" />
                ))}
              </div>
              
              <blockquote className="text-[#894D1D] font-montserrat mb-6 text-lg leading-relaxed">
                "{testimonial.quote}"
              </blockquote>
              
              <div className="border-t border-[#894D1D]/10 pt-4">
                <div className="font-semibold text-[#894D1D] font-montserrat">
                  {testimonial.author}
                </div>
                <div className="text-sm text-[#894D1D]/70 font-montserrat">
                  {testimonial.role}
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};

export default TestimonialsSection;
